import { logDebug, loadScript, hasScript, getCidFromCookie } from './utils'
import pluginConfig from './config'
/**
 * Plugin main class
 */
var inBrowser = typeof window !== 'undefined'

export default class AnalyticsPlugin {
    _clientId = null

    enabled() {
        return pluginConfig.enabled
    }

    enable(val) {
        pluginConfig.enabled = val

        if (inBrowser && !!val && !hasScript() && pluginConfig.loadScript) {
            loadScript(pluginConfig.id, pluginConfig.queryParams)
        }
    }

    debugEnabled() {
        return pluginConfig.debug
    }

    debug(val) {
        pluginConfig.debug = val
    }

    push(data) {
        if (inBrowser && pluginConfig.enabled) {
            data.cid = this.clientId

            let dataLayer = (window.dataLayer = window.dataLayer || [])
            dataLayer.push(data)

            return true
        }

        return false
    }

    get clientId() {
        if (this._clientId) {
            return this._clientId
        }

        this._clientId = getCidFromCookie()

        if (!this._clientId) {
            logDebug('Warning: cookie CID empty value!', this._clientId)
        }

        return this._clientId
    }

    trackView(screenName, path) {
        if (inBrowser && pluginConfig.enabled) {
            logDebug('Dispatching TrackView', { screenName, path })

            this.push({
                event: 'content-view',
                'content-name': path,
                'content-view-name': screenName,
            })
        }
    }

    trackEvent({
        event = null,
        category = null,
        action = null,
        label = null,
        value = null,
        noninteraction = false,
        ...rest
    } = {}) {
        if (inBrowser && pluginConfig.enabled) {
            logDebug('Dispatching event', {
                event,
                category,
                action,
                label,
                value,
                ...rest,
            })

            this.push({
                event: event || 'interaction',
                target: category,
                action: action,
                'target-properties': label,
                value: value,
                'interaction-type': noninteraction,
                ...rest,
            })
        }
    }

    trackCustomEvent(event, params) {
        if (inBrowser && pluginConfig.enabled) {
            logDebug('Dispatching custom event', {
                ...params,
                event,
            })

            this.push({
                event,
                ...params,
            })
        }
    }

    trackEcommerceEvent(ecommerce, action, noninteraction, rest) {
        if (!ecommerce.currencyCode) ecommerce.currencyCode = 'USD'

        if (inBrowser && pluginConfig.enabled) {
            logDebug('Dispatching ecommerce event', {
                ecommerce,
                action,
                noninteraction,
                ...rest,
            })

            this.push({
                ecommerce,
                event: 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': action,
                'gtm-ee-event-non-interaction': noninteraction,
                ...rest,
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/plugins/vue-gtm/GtmPlugin.js